import { render } from "./ExternalMcpOAuthDialog.vue?vue&type=template&id=c01c544a&ts=true"
import script from "./ExternalMcpOAuthDialog.vue?vue&type=script&lang=ts"
export * from "./ExternalMcpOAuthDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__